import React, { useMemo } from 'react';

interface ChatMessageBubbleProps {
  children: React.ReactNode;
  borderless?: boolean;
  transparent?: boolean;
  fullWidth?: boolean;
  message?: {
    type?: string;
    smartFormStyle?: boolean;
  };
}

const ChatMessageBubble = function ({
  children,
  borderless = false,
  transparent = false,
  fullWidth = false,
  message = undefined,
}: ChatMessageBubbleProps) {
  const { type = '', smartFormStyle = false } = message || {};
  const loadingMessage = type === 'typing';
  const mods = useMemo(() => {
    let allClasses = 'mod--fullBubble';
    allClasses = borderless ? `${allClasses} mod--borderless` : allClasses;
    allClasses = transparent ? `${allClasses} mod--transparent` : allClasses;
    allClasses = fullWidth ? `${allClasses} mod--fullWidth` : allClasses;
    allClasses = smartFormStyle ? `${allClasses} mod--smartForm` : allClasses;
    return allClasses;
  }, [
    borderless,
    transparent,
    fullWidth,
    smartFormStyle,
  ]);

  return (
    <div className={!(loadingMessage && smartFormStyle) ? `chat-message ${mods}` : undefined}>
      <div className="chat-message-text-section">
        {children}
      </div>
    </div>
  );
};

export default ChatMessageBubble;
